import React, {Component} from 'react';
import firebase from '../Configs/firebase'
import HostingItem from '../Models/HostingItem'

class ItemList extends Component{
    constructor(props){
        super(props)
        this.state = {
            geoTiffsArray : [],
            shapefilesArray : []
        }

        this.handleDelete = this.handleDelete.bind(this)
        this.listDroneHosting = this.listDroneHosting.bind(this)
    }

    componentDidMount(){
        this.listDroneHosting()
    }

    listDroneHosting(){
        const { user,folder } = this.props
        var geoTiffsArray = []
        var shapefilesArray = []
        firebase.firestore().collection('drone_hostings').where('uid','==',user.uid).where('type','==',folder).orderBy('created_date','desc').get()
        .then(docSnapshots=>{
            docSnapshots.forEach(docSnapshot=>{
                var hostingItem = HostingItem.initBySnapshot(docSnapshot)
                if(folder === 'tiff'){
                    geoTiffsArray.push(hostingItem)
                }
                else{
                    shapefilesArray.push(hostingItem)
                }
            })
            this.setState({
                geoTiffsArray:geoTiffsArray,
                shapefilesArray:shapefilesArray
            })
        })
    }

    handleDelete(hostingItem){
        const { user } = this.props
        var r = window.confirm('ต้องการลบ '+ hostingItem.folderName+' ใช่หรือไม่')
        let batch = firebase.firestore().batch()
        if(!r) return

        let userRef = firebase.firestore().collection('users').doc(user.uid)
        let droneHostingRef = firebase.firestore().collection('drone_hostings').doc(hostingItem.id)
        let deletedHostingRef = firebase.firestore().collection('drone_deleted').doc('d'+hostingItem.id)
        let droneRef = null

        batch.update(userRef,{available_storage:user.available_storage+hostingItem.size})
        batch.delete(droneHostingRef)
        batch.set(deletedHostingRef,hostingItem.createObjectForFirestore(user.uid))
            
        if(hostingItem.link !== ''){
            var droneId = hostingItem.link.split('drone/')
            droneRef = firebase.firestore().collection('drones').doc(droneId[1])
            batch.delete(droneRef)
        }
        
        batch.commit()
        .then(()=>{
            alert(' ลบไฟล์สำเร็จ ')
        })
        .then(()=>{
            this.listDroneHosting()
            this.props.setUser(user)
        })
        
    }

    render(){
        const { folder } = this.props
        const { geoTiffsArray, shapefilesArray } = this.state
        var listOutput = null
        let buttonPremission = null

        if(folder === 'tiff'){
            if( geoTiffsArray.length > 0){
                listOutput = geoTiffsArray.map((folder,index)=>{
                    var statusColor = 'darkgray'
                    if(folder.status === 'เกิดข้อผิดพลาด') statusColor = '#ffcc00'
                    else if(folder.status === 'สำเร็จ') {
                        statusColor = 'green'
                        buttonPremission = <button onClick={()=>this.props.handleManagePermision(folder)}>จัดการสิทธิ์</button>
                    }
                    return  <tr key={folder.id}>
                                    <td><i className="far fa-image"></i></td>
                                    <td style={{width:"20%"}}><label>{folder.folderName}</label></td>
                                    <td><label>{folder.sizeString()}</label></td>
                                    <td><label>{folder.createdAtString()}</label></td>
                                    <td><label style={{color:statusColor}}>{folder.status}</label></td>
                                    <td style={{width:"30%"}}><a href={folder.link}>{folder.link}</a></td>
                                    <td>{buttonPremission}</td>
                                    <td><button onClick={()=>this.handleDelete(folder)}>ลบ</button></td>
                            </tr>
                })
            }
            else listOutput = <tr><td><label>กรุณาอัพโหลด</label></td></tr>
        }
        else{
            if( shapefilesArray.length > 0){
                listOutput = shapefilesArray.map((folder,index)=>{
                    var statusColor = 'darkgray'
                    if(folder.status === 'เกิดข้อผิดพลาด') statusColor = '#ffcc00'
                    else if(folder.status === 'สำเร็จ') {
                        statusColor = 'green'
                        buttonPremission = <button onClick={()=>this.props.handleManagePermision(folder)}>จัดการสิทธิ์</button>
                    }
                    return  <tr key={folder.id}>
                                <td ><i className="far fa-image"></i></td>
                                <td style={{width:"20%"}}><label>{folder.folderName}</label></td>
                                <td><label>{folder.sizeString()}</label></td>
                                <td><label>{folder.createdAtString()}</label></td>
                                <td><label style={{color:statusColor}}>{folder.status}</label></td>
                                <td style={{width:"30%"}}><a href={folder.link}>{folder.link}</a></td>
                                <td>{buttonPremission}</td>
                                <td><button onClick={()=>this.handleDelete(folder)}>ลบ</button></td>
                            </tr>
                })
            }
            else listOutput = <tr><td><label>กรุณาอัพโหลด</label></td></tr>
        }
        return (
            <table style={{width:"100%"}}>
                <tbody>
                    {listOutput}
                </tbody>
            </table>
           
        )
    }
}

export default ItemList


// WEBPACK FOOTER //
// ./src/PageManagement/_ItemList.js